module.exports = __webpack_public_path__ + "img/android-download-en.cc754c07.png";